export const COMIC_USER_READING_STATUS_ALL = "0";